var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"12","fill":"#2D7393"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"7","fill":"#FFF"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }